import ToggleColumns from "@/components/table-utils/toggle-columns";
import { type Table as ReactTableType } from "@tanstack/react-table";
import { PiMagnifyingGlassBold } from "react-icons/pi";
import { Flex, Input } from "rizzui";

interface TableToolbarProps<T extends Record<string, any>> {
    table: ReactTableType<T>;
}

export default function Filters<TData extends Record<string, any>>({
    table,
}: TableToolbarProps<TData>) {
    return (
        <Flex align="center" justify="between" className="mb-4">
            <Input
                type="search"
                placeholder="Search by category name..."
                value={table.getState().globalFilter ?? ""}
                onClear={() => table.setGlobalFilter("")}
                onChange={(e) => table.setGlobalFilter(e.target.value)}
                inputClassName="h-9"
                clearable={true}
                prefix={<PiMagnifyingGlassBold className="size-4" />}
            />

            <ToggleColumns table={table} />
        </Flex>
    );
}
